import Button from "react-bootstrap/Button";
import React, {useState} from "react";
import {Modal} from "react-bootstrap";
import moment from "moment/moment";
import {Alert, ErrorBoundary, Loading} from "fearless-common-ui";
import {StripeInvoice} from "fearless-common";
import {defaultDateFormat} from "../../utils/date";
import useGet from "../hooks/useGet";
import {backendEndpoints} from "../../libs/backendEndpoints";
import AmountSpan from "../billing/AmountSpan";

/**
 * Show the invoices belonging to a specific subscription.
 */
export default function SubscriptionInvoicesModal({ subscriptionId }: {
  /** The subscription ID */
  subscriptionId: number
}) {
  const [show, setShow] = useState(false);
  const { data, isLoading, error } = useGet<StripeInvoice[]>({
    endpoint: show ? backendEndpoints.stripeInvoices(subscriptionId) : '',
  });

  return (
    <>
      <Button variant="outline-secondary mb-1" onClick={() => setShow(true)}>
        Invoices&rarr;
      </Button>
      {show && (
        <Modal show onHide={() => setShow(false)} size="lg">
          <Modal.Header closeButton>
            <Modal.Title>Invoices</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <ErrorBoundary>
              {error && <Alert>{error}</Alert>}
              {isLoading && <Loading />}
              <table className="table table-sm">
                <thead>
                <tr>
                  <th>Date of issue</th>
                  <th>Period</th>
                  <th>Total amount</th>
                  <th>Download</th>
                </tr>
                </thead>
                <tbody>
                {Array.isArray(data) && data?.map((invoice) => (
                  <tr>
                    <td>
                      {moment(invoice.created * 1000).format(defaultDateFormat)}
                    </td>
                    <td>
                      {moment(invoice.period_start * 1000).format(defaultDateFormat)}
                      -
                      {moment(invoice.period_end * 1000).format(defaultDateFormat)}
                    </td>
                    <td>
                      <AmountSpan.Amount currency={invoice.currency} amount={invoice.total / 100} />
                    </td>
                    <td>
                      {invoice.invoice_pdf ? <a target="_blank" rel="noreferrer" href={invoice.invoice_pdf}>PDF</a> : <i className="neutral400">Invoice not finalized</i>}
                    </td>
                  </tr>
                ))}
                </tbody>
              </table>
            </ErrorBoundary>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="outline-primary" onClick={() => setShow(false)}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
}
